import React, { ReactNode, HTMLProps, memo } from 'react'

type Props = HTMLProps<HTMLTableRowElement> & {
  children: ReactNode
  className?: string
  variant?: 'thead' | 'tbody'
}

export const Tr = memo(({ children, ...rest }: Props) => <tr {...rest}>{children}</tr>)
